var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSortAscending = function SvgIconSortAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6a1 1 0 0 1 1-1h12.75a1 1 0 1 1 0 2H4.5a1 1 0 0 1-1-1M17.25 9.5a1 1 0 0 1 1 1v6.586l2.043-2.043a1 1 0 0 1 1.414 1.414l-3.75 3.75-.006.007a1 1 0 0 1-.698.286h-.006a1 1 0 0 1-.698-.286l-.007-.008-3.75-3.749a1 1 0 0 1 1.415-1.414l2.043 2.043V10.5a1 1 0 0 1 1-1M4.5 11a1 1 0 1 0 0 2h6.75a1 1 0 1 0 0-2zM4.5 17a1 1 0 1 0 0 2h5.25a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconSortAscending;